import React from 'react';
import { DateInput } from '@mantine/dates';
import { BaseFieldProps } from './types';
import dayjs from 'dayjs';

const DATE_FORMATS = [
  // ISO format
  'YYYY-MM-DD',
  // Common UK date formats
  'DD/MM/YYYY',
  'DD-MM-YYYY',
  'DD.MM.YYYY',
  // Compact UK date formats
  'DDMMYYYY',
  // Two-digit year formats
  'DD/MM/YY',
  'DD-MM-YY',
  'DD.MM.YY',
  'DDMMYY',
];

function parseUKDate(input: string): Date | null {
  if (!input?.trim()) return null;
  const trimmed = input.trim();

  for (const format of DATE_FORMATS) {
    const parsed = dayjs(trimmed, format, true);
    if (parsed.isValid()) {
      return parsed.toDate();
    }
  }

  return null;
}

export function DateField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  rightValue,
  form,
  formFieldName,
  variant,
  fieldName,
  onChange,
}: BaseFieldProps<T>) {
  const inputProps = form.getInputProps(formFieldName);

  return (
    <DateInput
      id={formFieldName}
      required={!entityMetadata.isOptional}
      clearable
      label={fieldLabel}
      labelProps={{ variant: 'light' }}
      disabled={disabled}
      rightSection={rightValue}
      placeholder="DD/MM/YYYY"
      valueFormat="D MMMM YYYY"
      {...inputProps}
      dateParser={parseUKDate}
      key={form.key(formFieldName)}
      variant={variant}
      value={inputProps.value ? dayjs(inputProps.value).toDate() : inputProps.value}
      defaultValue={
        inputProps.defaultValue ? dayjs(inputProps.defaultValue).toDate() : inputProps.defaultValue
      }
      onChange={value => onChange(value, fieldName)}
      allowDeselect={false}
    />
  );
}
